import type React from 'react';
import classNames from 'classnames';

import Badge from 'components/partials/badge/badge';
import { useSideMenuPopoverTrigger } from 'components/shared/side-menu/hooks';
import { SIDE_MENU_POPOVER_GAP } from 'components/shared/side-menu/side-menu.constants';

import type { NavItemBadge } from 'components/shared/side-menu/nav-config';

interface BaseSideMenuBadgeProps {
  badge?: NavItemBadge;
  getPopoverAnchorElement?: () => HTMLElement | null;
  getPopoverFallbackAnchorElement?: () => HTMLElement | null;
  anchorGap?: number;
}

const BaseSideMenuBadge = ({
  badge,
  getPopoverAnchorElement,
  getPopoverFallbackAnchorElement,
  anchorGap = SIDE_MENU_POPOVER_GAP.row,
}: BaseSideMenuBadgeProps): React.JSX.Element | null => {
  const { trigger, openPopoverNow } = useSideMenuPopoverTrigger({
    popover: badge?.popover,
    getPopoverAnchorElement,
    getPopoverFallbackAnchorElement,
    anchorGap,
  });

  if (!badge) return null;

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (trigger !== 'badge') return;

    openPopoverNow(event.currentTarget);
  };

  return (
    <Badge
      text={badge.text}
      variant={badge.variant ?? 'neutral-outlined'}
      className={classNames('shrink-0', badge.className)}
      onMouseEnter={handleMouseEnter}
    />
  );
};

export default BaseSideMenuBadge;
